import { Link } from 'react-router-dom';
import { GovIcon } from '@gov-design-system-ce/react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import type { Nullable } from '@gov-nx/core/types';
import { PageCode } from '@gov-nx/module/page';
import { limitNumber } from '@gov-nx/utils/common';

interface DataBoxItemNavigationItemProps {
	active: boolean;
	label: string;
	url: string;
	unreadMessagesCount?: Nullable<number>;
	icons: { default: string; active: string };
}

export const DataBoxItemNavigationItem = ({
	active,
	label,
	url,
	unreadMessagesCount,
	icons,
}: DataBoxItemNavigationItemProps) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);

	const getUnreadMessagesBadge = (unreadMessagesCount: number) => (
		<span
			className="flex items-center px-1 h-4 text-body-xs! bg-(--button-solid-secondary) text-(--color-primary-700)! rounded-full"
			aria-label={tn('zpravy.neprectene-zpravy')}>
			{limitNumber(unreadMessagesCount)}
		</span>
	);

	if (active) {
		return (
			<li className="anim-bg-hover h-(--height-component-m) bg-(--background-primary-subtle) rounded-lg">
				<Link
					to={url}
					className="flex justify-between items-center w-full py-2 px-(--spacing-m) text-(--text-primary-color) font-bold no-underline! [ before:absolute before:left-0 before:w-1 before:h-full before:bg-(--border-primary) before:rounded-l-lg ]">
					<span className="flex items-center justify-start gap-3">
						<GovIcon
							name={icons.default}
							type="templates"
							size="m"
						/>
						{label}
					</span>
					{!!unreadMessagesCount && getUnreadMessagesBadge(unreadMessagesCount)}
				</Link>
			</li>
		);
	}

	return (
		<li className="anim-bg-hover h-(--height-component-m) rounded-lg [ hover:bg-(--button-outlined-primary-hover) ]">
			<Link
				to={url}
				className="flex justify-between items-center w-full py-2 px-(--spacing-m) text-(--text-secondary) no-underline!">
				<span className="flex items-center justify-start gap-3">
					<GovIcon
						name={icons.active}
						type="templates"
						className="w-4 text-(--text-primary-color)"
					/>
					{label}
				</span>
				{!!unreadMessagesCount && getUnreadMessagesBadge(unreadMessagesCount)}
			</Link>
		</li>
	);
};
